import type { ICommittedActivity } from '../apis/activities.js';
import type { EntityRef } from '../interfaces/ICommsApi.js';

/**
 * The site's committed activities as `@` picker rows. The feed has one row per
 * schedule and task, so a copied programme lists a task twice under one id;
 * a mention carries only the id, so the picker offers each id once.
 */
export function activityMentionRefs(activities: readonly ICommittedActivity[]): EntityRef[] {
  const seen = new Set<string>();
  const refs: EntityRef[] = [];
  for (const { task } of activities) {
    if (seen.has(task.id)) continue;
    seen.add(task.id);
    refs.push({ kind: 'activity', id: task.id, label: task.name });
  }
  return refs;
}
